import axios from 'axios'

export default axios.create({
    baseURL : "https://nur.porichorja.org/api"
})